import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Jumbo } from "../components/jumbo";
import { BlockRenderer } from "../components/block_renderer";
export class GeneralContentPage extends React.Component {
    componentDidMount() {
        document.title = this.props.pageTitle;
    }
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "general-page",
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: p.headerTitle,
                    contents: p.description,
                    imageUrlSmall: p.jumboSize == 'small' && p.phImageUrlSmall ? p.phImageUrlSmall : undefined,
                    imageUrl: p.phImageUrl,
                    imageUrlFallback: p.phImageUrlFallback,
                    imageUrlLarge: p.phImageUrlLarge,
                    imageAlt: p.imageAlt,
                    buttonUrl: p.buttonUrl,
                    buttonTitle: p.buttonTitle,
                    size: p.jumboSize
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "general-page__content",
                    children: /*#__PURE__*/ _jsx(BlockRenderer, {
                        blocks: p.blocks
                    })
                })
            ]
        });
    }
}
{}